import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import {
  Hospitalisation,
  Patient,
  Billet,
  TransferDemand,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getServiceId,
  getUserId,
  getUserShortName,
  isToday,
  jsonAbstract,
} from "@/src/utils/utils";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import { openBillet } from "../../admission/billet";
import { openTransferDrawer } from "../transferDemands";

export default function BilletCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: Billet;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: Billet) => void;
}) {
  async function openBilletForm() {
    let item: Billet = {
      type: "billet",
      patient,
      creator: getUserId(),
      parent,
      functionalSigns: [],
      physicalSigns: [],
      readBy: [getUserId()],
      confidentiality: getStandardConfidentiality(patient),
    };

    return await openBillet({
      item,
      parent,
      patient,
      onChange: (item) => {
        onChange(item);
      },
    });
  }

  if (!item.id)
    return (
      <div
        className="card redish tcenter"
        onClick={async () => {
          if (!parent.bed) {
            let transfer: TransferDemand = {
              type: "transferDemand",
              status: "pending",
              notes: "",
              patient,
              parent: jsonAbstract(parent.id),
              creator: getUserId(),
              acceptedBy: null,
              service: null,
              unit: null,
              exitDate: null,
              confidentiality: getStandardConfidentiality(patient),
              readBy: [getUserId()],
            };

            await openTransferDrawer(parent, transfer, (transfer) => {
              // setReload((prev) => prev + 1);
            });
            return;
          }

          await openBilletForm();
        }}
      >
        <div className="bold">Billet de salle</div>
        <div>Aucune donnée saisie</div>
      </div>
    );

  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={"Billet de salle"}
      subTitle={getUserShortName(item?.creator) || ""}
      onEdit={async () => {
        await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("billets", "addOne", {
              billet: newItem,
            });
            onChange?.(newItem);
          },
        });
      }}
      onClick={async () => {
        await openBillet({
          item: item,
          parent: parent,
          patient,
          onChange: (billet) => {
            onChange(billet);
          },
        });
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("billets", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    ></Card>
  );
}
